import React from 'react'
import {
    UiOrderDetails,
    UiOrderDetailsColWr,
    UiOrderDetailsColName,
    UiOrderDetailsHr,
    UiOrderDetailsColStatus,
    UiOrderDetailsColValidUnit,
    UiOrderDetailsColLabel
} from "../../../components/common/UiProductElements"
import { UiCol, UiRowContainer, UiSingleContainer, UiSingleRow } from "../../../components/grid-container/GridContainer"


export default function OrderTopDetails(props) {

    return (
        <>
            <UiOrderDetails title="Order Details">
                <UiSingleRow>
                    <UiCol lg="4">
                        <UiOrderDetailsColWr>
                            <UiOrderDetailsColName colName="Order Number" />
                            <UiOrderDetailsColLabel label="9238BCD" />
                        </UiOrderDetailsColWr>
                        <UiOrderDetailsColWr>
                            <UiOrderDetailsColName colName="Date" />
                            <UiOrderDetailsColLabel label="Monday 22nd March 2023" />
                        </UiOrderDetailsColWr>
                    </UiCol>
                    <UiCol lg="4">
                        <UiOrderDetailsColWr>
                            <UiOrderDetailsColName colName="Order Name" />
                            <UiOrderDetailsColLabel label="London version 3 trip" />
                        </UiOrderDetailsColWr>
                        <UiOrderDetailsColWr>
                            <UiOrderDetailsColName colName="Points Total" />
                            <UiOrderDetailsColLabel label="4,750 Points" />
                        </UiOrderDetailsColWr>
                    </UiCol>
                    <UiCol lg="4">
                        <UiOrderDetailsColWr>
                            <UiOrderDetailsColName colName="Status" />
                            <UiOrderDetailsColStatus status="Valid" />
                        </UiOrderDetailsColWr>
                        <UiOrderDetailsColWr>
                            <UiOrderDetailsColName colName="Valid Unit" />
                            <UiOrderDetailsColValidUnit validUnit="23th May 2023" />
                        </UiOrderDetailsColWr>
                    </UiCol>
                </UiSingleRow>
                <UiOrderDetailsHr />
            </UiOrderDetails>
        </>
    )
}
